import { render, staticRenderFns } from "./benefitDialog.vue?vue&type=template&id=8efd1ade&scoped=true&"
import script from "./benefitDialog.vue?vue&type=script&lang=js&"
export * from "./benefitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efd1ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8efd1ade')) {
      api.createRecord('8efd1ade', component.options)
    } else {
      api.reload('8efd1ade', component.options)
    }
    module.hot.accept("./benefitDialog.vue?vue&type=template&id=8efd1ade&scoped=true&", function () {
      api.rerender('8efd1ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/branch/dialog/benefitDialog.vue"
export default component.exports